import React, {useState} from 'react';
import {Box, Button, Grid} from '@mui/material';
import {Link} from 'react-router-dom';
import {JobDetailsTab} from '../../../components/ai/review/common/JobDetails/JobDetailsTab';

export const jobDetails = {
  jobId: '2',
  createdBy: 'Antonio Marghereti',
  status: 'Complete',
  selectedSource: 'Saved Search - FraudDocs22',
  caseContext: `Wrongful termination and discrimination claim filed by former senior manager. Key issues include alleged age discrimination, retaliation for whistleblower complaints regarding financial irregularities, and breach of employment contract terms regarding severance. Wrongful termination and discrimination claim filed by former senior manager. Key issues include alleged age discrimination, retaliation for whistleblower complaints regarding financial irregularities, and breach of employment contract terms regarding severance.

Wrongful termination and discrimination claim filed by former senior manager. Key issues include alleged age discrimination, retaliation for whistleblower complaints regarding financial irregularities, and breach of employment contract terms regarding severance.Wrongful termination and discrimination claim filed by former senior manager. Key issues include alleged age discrimination, retaliation for whistleblower complaints regarding financial irregularities, and breach of employment contract terms regarding severance.

Wrongful termination and discrimination claim filed by former senior manager. Key issues include alleged age discrimination, retaliation for whistleblower complaints regarding financial irregularities, and breach of employment contract terms regarding severance.Wrongful termination and discrimination claim filed by former senior manager. Key issues include alleged age discrimination, retaliation for whistleblower complaints regarding financial irregularities, and breach of employment contract terms regarding severance.

Wrongful termination and discrimination claim filed by former senior manager. Key issues include alleged age discrimination, retaliation for whistleblower complaints regarding financial irregularities, and breach of employment contract terms regarding severance.Wrongful termination and discrimination claim filed by former senior manager. Key issues include alleged age discrimination, retaliation for whistleblower complaints regarding financial irregularities, and breach of employment contract terms regarding severance.`,
  issueCode: [
    {
      title: 'Trade-Secret',
      text: `Documents that contain or discuss TechDynamics' proprietary algorithms, formulas, or technical processes labeled as confidential.`,
    },
    {
      title: 'Source-Code',
      text: `Raw code files, snippets, or diffs. Includes discussion of specific function names, variable names, or architectural patterns unique to Project Nexus.`,
    },
    {
      title: 'VC-Funding',
      text: `Communications with Venture Capital firms, angel investors, or term sheets. Specifically looks for discussions of valuation or seed rounds.`,
    },
    {
      title: 'Data-Exfiltration',
      text: `Evidence of unauthorized data transfer. Includes logs of uploads to Dropbox/Google Drive, use of USB devices, or emailing files to personal accounts.`,
    },
    {
      title: 'Fiduciary-Breach',
      text: `Actions taken by the defendants while employed that conflict with TechDynamics' interests. Includes soliciting colleagues or working on the competitor product on company time.`,
    },
    {
      title: 'Forensic-Evidence',
      text: `Technical logs, metadata analysis, or security audit reports. Documents that prove when and how files were accessed or modified.`,
    },
    {
      title: 'Product-Roadmap',
      text: `Strategic planning documents for either Project Nexus or PredictAI. Includes feature lists, launch timelines, and market analysis.`,
    },
    {
      title: 'Employment-Agreements',
      text: `Contracts, NDAs, non-compete clauses, and resignation correspondence. Relevant to establishing the legal duties of the defendants.`,
    },
    {
      title: 'Privileged',
      text: `Attorney-Client communication or Attorney Work Product. Any communication involving legal counsel for either party regarding the dispute.`,
    },
  ],
  relevanceCriteria:
    'A document is responsive if it contains information related to: (1) the 40% vs. 25% royalty structure for exclusive vs. non-exclusive audiobook distribution; (2 policies or decisions preventing authors from switching from non-exclusive to exclusive distribution; (3) 90-day exclusivity rules for ACX titles; (4) Audible’s distribution fees, pricing, or promotional practices for exclusive or non-exclusive titles; (5) Audible’s relationship with Apple regarding audiobook distribution; (6) Audible’s DRM policies or ability to port audiobooks to competing platforms; (7) market share, consumer behavior, or competitive analysis related to the audiobook market; (8) communications with Brandon Sanderson about distribution terms or royalty rates; or (9) distribution of audiobooks to libraries or lending platforms.',
};

const AIReviewJobDetailsDemo: React.FC = () => {
  const [type, setType] = useState<string>('Issue Coding');
  return (
    <Box className="ai-thinking-demo">
      <h1>AIReviewJobDetails</h1>
      <hr />
      <Link to="/demo" className="link">
        Return
      </Link>
      <hr />
      <hr />
      <Button
        onClick={() =>
          setType((prev) =>
            prev === 'Issue Coding' ? 'Relevancy' : 'Issue Coding'
          )
        }
        data-testid="aireview-job-details-demo-button">
        {`Switch Type`}
      </Button>
      <hr />
      <Grid container spacing={2} paddingTop={10} className="job-details-box">
        <JobDetailsTab type={type} jobDetails={jobDetails} />
      </Grid>
    </Box>
  );
};

export default AIReviewJobDetailsDemo;
